"use strict";
/**
 * 一键快签 - 编辑推送 弹窗
 * 2019-05-06
 * fanglijuan
 */
angular.module("appQuickSignEditPushDetailModule", []).
controller("appQuickSignEditPushDetailCtrl", ['$scope', '$q', '$state', '$modalInstance', '$stateParams', '$filter', '$element', '$validation', "modalDialog", "trsHttpService", "trsspliceString", "obj", "itemInfo", "selectedArray", "editingCenterService", "appQuickSignService",
    function($scope, $q, $state, $modalInstance, $stateParams, $filter, $element, $validation, modalDialog, trsHttpService, trsspliceString, obj, itemInfo, selectedArray, editingCenterService, appQuickSignService) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                modalTitle: "编辑推送",
                indexName: "",
                channelid: itemInfo.CHANNELID,
                siteid: itemInfo.SITEID,
                selectedArray: selectedArray,
            };
            $scope.data = {};
            $scope.params = {
                typeid: "zyzx",
                serviceid: "iwo",
                modelid: "detailData",
                guid: obj.GUID
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }

        /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
                $scope.data = data.content[0];
                //$scope.status.indexName = data.summary_info.indexName;
            });
        }

        //确定
        $scope.confirm = function() {
            $validation.validate($scope.quickSignEditPushDetailForm).success(function() {
                modalDialog.confirmModal("签发", "确定签发已选择的稿件吗？", function() {
                    var jsonObj = {};
                    jsonObj[obj.GUID] = obj.HYBASEID;
                    var params = {
                        serviceid: "mlf_appquickpublish",
                        methodname: "quickpub",
                        CHANNELID: $scope.status.channelid,
                        SITEID: $scope.status.siteid,
                        CATEGORYID: JSON.stringify(jsonObj),
                        ListTitle: $scope.data.DOCTITLE,
                        content: $scope.data.CLEAR_CONTENT,
                        reltype: 2,
                        indexName: obj.INDEXNAME, //数据库名
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                        modalDialog.alertType("直接快签成功", "", "success", false);
                        $modalInstance.close('success');
                    });
                });
            }).error(function() {
                editingCenterService.checkSaveError($scope.quickSignEditPushDetailForm, $element, $scope); //定位输入错的表单位置
                modalDialog.alertType("请检查填写项", "", "warning", false, function() {});
            });
        };
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }
]);